// Public BAi HubSpot scheduler, shared by the BAi and Wellwired fit-call links.
export const fitCallUrl = process.env.REACT_APP_FIT_CALL_URL || 'https://meetings-na2.hubspot.com/tyler42';
